<template>
	<div v-if="Character.Equipment.Equipped.length > 0">
		<h5 class="mt-2">Equipped</h5>
		<ul class="list-inline mb-0" v-if="typeof(Character.Equipment.Equipped) != null">
			<li class="list-inline-item" v-for="(item, index) in Character.Equipment.Equipped" :key="'equipment-equipped-'+index">
				{{item.Name}}
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
	}
}
</script>

<style scoped>

</style>